"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSans = void 0;
const FontStatics_1 = require("./FontStatics");
class OpenSans {
}
OpenSans.FAMILY = "Open Sans";
OpenSans.BASE_URL = "/node_modules/@nolimitcity/slot-launcher/resources/default/fonts/opensans/";
OpenSans.NORMAL_300 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.LIGHT,
    style: FontStatics_1.FontStyle.NORMAL,
    url: OpenSans.BASE_URL + "OpenSans-Light-webfont.woff"
};
OpenSans.ITALIC_300 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.LIGHT,
    style: FontStatics_1.FontStyle.ITALIC,
    url: OpenSans.BASE_URL + "OpenSans-LightItalic-webfont.woff"
};
OpenSans.NORMAL_400 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.REGULAR,
    style: FontStatics_1.FontStyle.NORMAL,
    url: OpenSans.BASE_URL + "OpenSans-Regular-webfont.woff"
};
OpenSans.ITALIC_400 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.REGULAR,
    style: FontStatics_1.FontStyle.ITALIC,
    url: OpenSans.BASE_URL + "OpenSans-Italic-webfont.woff"
};
OpenSans.NORMAL_600 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.SEMI_BOLD,
    style: FontStatics_1.FontStyle.NORMAL,
    url: OpenSans.BASE_URL + "OpenSans-Semibold-webfont.woff"
};
OpenSans.ITALIC_600 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.SEMI_BOLD,
    style: FontStatics_1.FontStyle.ITALIC,
    url: OpenSans.BASE_URL + "OpenSans-SemiboldItalic-webfont.woff"
};
OpenSans.NORMAL_700 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.BOLD,
    style: FontStatics_1.FontStyle.NORMAL,
    url: OpenSans.BASE_URL + "OpenSans-Bold-webfont.woff"
};
OpenSans.ITALIC_700 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.BOLD,
    style: FontStatics_1.FontStyle.ITALIC,
    url: OpenSans.BASE_URL + "OpenSans-BoldItalic-webfont.woff"
};
OpenSans.NORMAL_800 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.EXTRA_BOLD,
    style: FontStatics_1.FontStyle.NORMAL,
    url: OpenSans.BASE_URL + "OpenSans-ExtraBold-webfont.woff"
};
OpenSans.ITALIC_800 = {
    family: OpenSans.FAMILY,
    weight: FontStatics_1.FontWeight.EXTRA_BOLD,
    style: FontStatics_1.FontStyle.ITALIC,
    url: OpenSans.BASE_URL + "OpenSans-ExtraBoldItalic-webfont.woff"
};
exports.OpenSans = OpenSans;
//# sourceMappingURL=OpenSans.js.map